<template>
  <div class="dropdown ">
    <a class="lang-anchor text-uppercase" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fas fa-globe"></i>
      <span class="d-none d-lg-inline ms-1">{{$i18n.locale}}</span>
    </a>

    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
      <li>
        <a src="#" class="dropdown-item" @click="changeLang('ru')">
          RU
        </a>
      </li>
      <li>
        <a src="#" class="dropdown-item" @click="changeLang('en')">
          EN
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import userService from "@/helpers/api/user.service";

export default {
  name: "_lang",
  data() {
    return {};
  },
  methods: {
    changeLang: function (lang) {
      this.$i18n.locale = lang
      window.$chatwoot.setLocale(lang);
      return userService.setLang({ lang: lang}).then((data) => {
        this.$store.commit('init/setUser', data.user)
      })
    }
  }
}
</script>

<style scoped>

</style>